export default __webpack_public_path__ + "static/media/icon_image.66aeee03.svg";